<template>
  <div>
    <card
      :showHr="false"
      class="home-card custom-shadow-card-header"
      :style="`height: ${height}px !important;`"
    >
      <span>
        <div class="row">
          <div class="col-12">
            <div class="row mb-4">
              <div class="col-6 col-md-8">
                <img
                  class="chart-logo"
                  src="/static/img/iconos/icono-color-calidad.svg"
                />
                <span class="ml-1 custom-title"
                  ><strong>{{ $t('quality.quality') }}</strong></span
                >
              </div>
              <div class="col-6 col-md-4 text-right">
                <span class="custom-subtitle text-muted">{{
                  $t('common_words.compliance_report')
                }}</span>
              </div>
            </div>
            <highcharts :options="chartOptions"></highcharts>
          </div>
        </div>
      </span>
      <div slot="footer" class="card-footer footer-date-at custom-opacity">
        <p class="text-white d-flex justify-content-between">
          <small class="ml-3">{{ $t('common_words.smart_cultivo') }}</small>
          <small class="mr-3">{{ $t('common_words.last_six_months') }}</small>
        </p>
      </div>
    </card>
  </div>
</template>

<script>
import axios from 'axios';
import { Chart } from 'highcharts-vue';
import Highcharts from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';
import MixinCharts from 'src/util/mixinCharts';
import i18n from 'src/i18n';

exportingInit(Highcharts);

export default {
  components: {
    highcharts: Chart,
  },
  props: {
    height: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      chartOptions: {},
      flag: null,
    };
  },
  mixins: [MixinCharts],

  watch: {
    '$i18n.locale': 'getChartLabels',
  },
  methods: {
    getChartLabels() {
      if (this.flag) {
        this.chartOptions = this.columns(
          this.flag,
          true,
          i18n.t('common_words.compliance_percentage')
        );
      }
    },
    getComplianceChartData() {
      return axios
        .get('/auth/quality/compliance-indicator')
        .then((response) => {
          response.data.height = `${this.height - 350}px`;
          this.flag = response.data;
          try {
            this.getChartLabels();
          } catch (error) {
            console.log('error: ', error);
          }
          this.chartOptions.lang = {
            drillUpText: `${i18n.t('common_words.return_to')} {series.name}`,
          };
        });
    },
  },
  async created() {
    await this.getComplianceChartData();
  },
};
</script>
